import React from 'react';

type StatusVariant =
  | 'active' | 'expiring' | 'expired' | 'transferred' |'verified'| 'processing' | 'needs-review' | 'archived' |'submitted'| 'assigned' | 'in-progress' | 'resolved' | 'closed' | 'draft' |'registered'| 'under-service' |'success' | 'warning' | 'danger' | 'info' | 'neutral';

interface StatusBadgeProps {
  variant: StatusVariant;
  label: string;
  size?: 'sm' | 'md';
}

const variantStyles: Record<StatusVariant, string> = {
  active: 'bg-success/10 text-success border-success/20',
  expiring: 'bg-warning/10 text-warning border-warning/20',
  expired: 'bg-danger/10 text-danger border-danger/20',
  transferred: 'bg-info/10 text-info border-info/20',
  verified: 'bg-success/10 text-success border-success/20',
  processing: 'bg-info/10 text-info border-info/20',
  'needs-review': 'bg-warning/10 text-warning border-warning/20',
  archived: 'bg-muted text-muted-foreground border-border',
  submitted: 'bg-info/10 text-info border-info/20',
  assigned: 'bg-secondary text-secondary-foreground border-primary/20',
  'in-progress': 'bg-warning/10 text-warning border-warning/20',
  resolved: 'bg-success/10 text-success border-success/20',
  closed: 'bg-muted text-muted-foreground border-border',
  draft: 'bg-muted text-muted-foreground border-border',
  registered: 'bg-success/10 text-success border-success/20',
  'under-service': 'bg-warning/10 text-warning border-warning/20',
  success: 'bg-success/10 text-success border-success/20',
  warning: 'bg-warning/10 text-warning border-warning/20',
  danger: 'bg-danger/10 text-danger border-danger/20',
  info: 'bg-info/10 text-info border-info/20',
  neutral: 'bg-muted text-muted-foreground border-border',
};

export default function StatusBadge({ variant, label, size = 'md' }: StatusBadgeProps) {
  const sizeClass = size === 'sm' ? 'text-[10px] px-1.5 py-0.5' : 'text-xs px-2 py-0.5';
  return (
    <span className={`inline-flex items-center font-500 rounded-full border ${sizeClass} ${variantStyles[variant]}`}>
      {label}
    </span>
  );
}